import React from 'react'
import { walletConnectIcon } from 'wallet-module/assets/images'
function WalletConnect({ handleWalletConnectClick }) {
  return (
    <div className="connect-wallet" onClick={handleWalletConnectClick}>
      <div className="wallet-icon">
        <img className="relative" src={walletConnectIcon} alt="virtua" />
      </div>
      <span>Continue with Walletconnect</span>
    </div>
  )
}

export default WalletConnect
